import React, { useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Box, Grid } from '@material-ui/core';
import { contragentStore, anketsStore, userStore } from 'stores';
import {
  LoanBorrower,
  LoanBorrowerSkeleton,
  OtherCategories,
  OtherCategoriesSkeleton,
  ScoreInfo,
  ScoreInfoSkeleton,
} from 'components';
import { ContragentInfoSkeleton, ContragentInfo } from './components/ContragentInfo';
import { categories, permissionAccessCategories } from './MainScreen.mock';

const MainScreen = observer(() => {
  const { contragentInfo, fetchState } = contragentStore;
  const { userData, fetchState: userDataState } = userStore;

  useEffect(
    () =>
      autorun(() => {
        contragentStore.getContragentInfo(anketsStore.anketId);
      }),
    [],
  );

  return (
    <Box mb={8}>
      <Grid container>
        <Grid item xs={12}>
          <Box mb={2}>
            {fetchState === 'pending' && <ContragentInfoSkeleton />}
            {fetchState === 'fulfilled' && (
              <ContragentInfo requisites={contragentInfo.baseRequisites} />
            )}
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box mb={2}>
            {fetchState === 'pending' && <ScoreInfoSkeleton />}
            {fetchState === 'fulfilled' && <ScoreInfo score={contragentInfo.score} />}
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box mb={2}>
            {fetchState === 'pending' && <LoanBorrowerSkeleton />}
            {fetchState === 'fulfilled' && (
              <LoanBorrower borrower={contragentInfo.initiator} screen="main" />
            )}
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box mb={2}>
            {userDataState === 'pending' && <OtherCategoriesSkeleton screen="main" />}
            {userDataState === 'fulfilled' && (
              <OtherCategories
                role={userData.role}
                categories={categories}
                permissionAccessCategories={permissionAccessCategories}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
});

export default MainScreen;
